import { Matrix } from '../../../../../FrontendBundle/Resources/js/ofcs';
import MoveConnectorItemCommand from '../command/moveConnectorItemCommand';
import ConnectorItem from '../item/connectorItem';
import LengthUnitField from './lengthUnitField';

/**
 * @class ConnectorOffsetField
 */
export default class ConnectorOffsetField extends LengthUnitField {
    type = 'connectorOffset';

    /**
     * Update field value with item value.
     *
     * @param {ItemInterface} item
     */
    updateValue(item) {
        this.setValue(item.get('lineOffset'));
    }

    /**
     * Update item value with field value.
     *
     * @param {ItemInterface} item
     * @param {number} difference (optional)
     */
    updateItem(item, difference) {
        const offset = this.getValue() + difference || this.getValue();
        const line = item.get('line').clone();
        const matrixStart = new Matrix();
        const history = this.editor.getCanvas().getHistory();
        const segment = item.getTargetSegment();

        matrixStart.rotate(segment.getAngle(), segment.startPoint.x, segment.startPoint.y);
        const matrixEnd = matrixStart.clone().translate(line.getLength() + offset, 0);
        matrixStart.translate(offset, 0);

        line.endPoint = segment.startPoint.clone().transform(matrixEnd);
        line.startPoint = segment.startPoint.clone().transform(matrixStart);

        item.validateLine(line, offset);
        this.updateValue(item);

        history.addAndExecuteCommand(new MoveConnectorItemCommand(item, line));
    }

    /**
     * Update item value with field value relative to a difference.
     *
     * @param {ItemInterface} item
     * @param {number} difference
     */
    updateItemRelative(item, difference) {
        this.updateItem(item, difference);
    }

    /**
     * Check if field is supported by item.
     *
     * @param {ItemInterface} item
     * @param {number} selectionLength
     *
     * @return {boolean}
     */
    isSupported(item, selectionLength) {
        return selectionLength === 1 && item instanceof ConnectorItem;
    }
}
